<div class="stepper-container course-container">
  <div (click)="onClose()" class="course-i cursor-pointer">
    <i class="material-icons ms-4 ms-lg-5">close</i>
  </div>
  <mat-stepper class="pt-2 pt-xl-3" #stepper animationDuration="300" linear
    class="{{ 'last-edited-step-' + stepper.selectedIndex }}">
    <mat-step [completed]="selectedElements.length>0">
      <div class="border-class my-2"></div>
      <div class="search-cont">
        <div class="s-in form-input" style="position:relative">
          <mat-icon class="input-icon">search</mat-icon>
          <input type="text" placeholder="Search..." class="form-control" [(ngModel)]="searchInput"
            (input)="onSearch($event)" (keyup.enter)="onGo()" />
        </div>
        <div class="go-b" (click)="onGo()">Go</div>
        <div class="s-item d-box " (click)="onFilterView()">
          <img src="assets/images/icons/filter_ic.svg" class="img-fluid">
        </div>
      </div>
      <app-filter *ngIf="isFilterShow" (childEvent)="callApi($event)" [fieldCol]="filterArr"></app-filter>
      <div class=" table-container mt-2">
        <table class=""  mat-table [dataSource]="dataSourceEmp"  #sortEmp="matSort" matSort  (matSortChange)="announceSortChange($event)" class="mat-elevation-z8 normal-td">
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox name="schedule" [(ngModel)]="isSelectAll" (change)="onSelectAll($event)" [disabled]="searchInput !== '' || this.filterObj.arr.length !== 0 "> </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let element">
              <mat-checkbox name="schedule" [(ngModel)]="element.selected" (change)="onSelectSingle($event,element)"></mat-checkbox>
            </td>
          </ng-container>       
          <ng-container matColumnDef="first_name">
            <th mat-header-cell *matHeaderCellDef style="width:35%"> Name</th>
            <td mat-cell *matCellDef="let element">
              <div class="d-flex">
                <div class="profile-img me-2">
                  <img *ngIf="!element.profile_picture" src="assets/images/icons/employee.png" class="img-fluid"  alt="">
                  <img *ngIf="element.profile_picture" [src]="imageURL+element.profile_picture"
                  onerror="this.src='assets/images/icons/employee.png';"   class="img-fluid" alt="">
                </div>
                <div class="">
                  <div>{{element.first_name}} {{element.last_name}}</div>
                  <div class="steel-blue">{{element.email}}</div>
                </div>
              </div>
            </td>
          </ng-container>    
          <ng-container matColumnDef="department">
            <th mat-header-cell *matHeaderCellDef>Department</th>
            <td mat-cell *matCellDef="let element">{{ element.department }}</td>
          </ng-container>
          <ng-container matColumnDef="phone_number">
            <th mat-header-cell *matHeaderCellDef>Phone Number</th>
            <td mat-cell *matCellDef="let element">{{ element.phone_number }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumnsEmp"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsEmp" [ngClass]="row.a_s==1 ? 'course-assign':''"></tr>
        </table>
        <div class="mat-table__message" *ngIf="dataSourceEmp.data.length == 0">
          <img src="assets/images/gifs/no_record_found.gif" class="img-fluid"alt="" />
        </div>
        <div class="pagination-cont" *ngIf="dataSourceEmp.data.length!=0">
          <div class="show-item">
            {{"COMMON.SIP" | translate}}
            <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event)"
              [(ngModel)]="config.itemsPerPage">
              <option [value]="item" *ngFor="let item of pageSizeOptions">
                {{ item }}
              </option>
            </select>
          </div>
          <div class="page-c">
            <ngb-pagination [collectionSize]="countEmp" [(page)]="config.currentPage" [pageSize]="config.itemsPerPage"
              [maxSize]="maxPaginationSize" (pageChange)="onPageChange($event)"></ngb-pagination>
          </div>
        </div>
      </div>
      <div class="text-end bottom-content">
        <div>
          <mat-error *ngIf="isFirstStepClicked && selectedElements.length==0" >Please select employee to proceed</mat-error>
        </div>       
        <button  mat-raised-button color="primary"  class="auth-form-btn mt-1 no-sh-btn" type="submit" (click)="onFirstNextClick()"> Next </button>
      </div>
    </mat-step>
    <mat-step>
      <div class=" table-container justify-content-center">
        <div class="summary-container ">
          <div class="text-center asset-img mt-2">
            <img src="assets/images/object_icons/assign_course.png" class="img-fluid" />
          </div>
          <h5 class="my-lg-4 my-3 text-center">{{"Your Asset is ready to go!!"|translate}}</h5>
          <div class="row">
            <div class="col-sm-6 mt-1 mt-sm-2 mt-lg-3 grey-txt">{{"Asset will be assigned to"|translate}}: </div>
            <div class="col-sm-6 ps-lg-5 mt-1 mt-sm-2 mt-lg-3 text-black">{{selectedElements.length}} users</div>
          </div>
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-end bottom-content">
        <button mat-stroked-button matStepperPrevious class="auth-form-btn outline-btn mt-1">
          Back
        </button>
        <button mat-raised-button color="primary" matStepperNext class="auth-form-btn mt-1 ms-3"
          (click)="onSubmitAssign()">
          Submit
        </button>
      </div>
    </mat-step>

    <ng-template matStepperIcon="edit" let-index="index">
      <div class="step-number">{{ index + 1 }}</div>
    </ng-template>
  </mat-stepper>
</div>
<app-loading-spinner></app-loading-spinner>